<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mt-2">
          <v-card-title style="color:#1f245b">Kondisi Historis
            <v-spacer></v-spacer>
            <v-dialog
              ref="dialog"
              v-model="modal2"
              :return-value.sync="dates"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-col cols="6">
                <v-text-field
                  v-model="dateRangeText"
                  label="Pick Date"
                  prepend-icon="mdi-clock-time-four-outline"
                  class="mt-6"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  
                ></v-text-field>
                </v-col>
              </template>
              <v-date-picker
                v-if="modal2"
                v-model="dates"
                full-width
                range
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="modal2 = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(dates);getDataDates(dates,setByLocation)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-card-title>
          
          <v-divider class="mx-2"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="data"
                  :items-per-page="10"
                  :calculate-widths="true"
                  :mobile-breakpoint="500"
                  :loading="tableLoad"
                  class="elevation-1"
                  item-key="did"
                  hide-default-footer
                  disable-pagination
                  disable-sort
                >
                <template v-slot:footer  v-if="!dateFilter">
                  <v-divider class="my-3"></v-divider>
                  <v-row>
                    <v-col> 
                      <v-btn icon class="float-right mx-2" color="#757575" @click="page++;getData(page,itemsPerPage,setByLocation)">
                        <v-icon>mdi-arrow-right</v-icon>
                      </v-btn>
                      <body-1 class="float-right mt-2 mx-2">
                        {{page}}
                      </body-1>
                      <span v-if="page==1">
                        <v-btn disabled icon class="float-right mx-2" color="#757575" @click="page--;getData(page,itemsPerPage,setByLocation)">
                          <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                      </span>
                      <span v-else>
                        <v-btn icon class="float-right mx-2" color="#757575" @click="page--;getData(page,itemsPerPage,setByLocation)">
                          <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                      </span>
                      <v-select
                        flat
                        single-line
                        dense
                        :items="[10,30,50]"
                        :value="10"
                        class="float-right mx-2"
                        v-model="itemsPerPage"
                        @change="getData(page,itemsPerPage,setByLocation)"
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:[`item.start`]="{ item }">
                  {{updateTime(item.start)}}
                </template>
                <template v-slot:[`item.end`]="{ item }">
                  {{updateTime(item.end)}}
                </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import firebase from "firebase/app"
import { db }from "../firebase/db.js"
import moment from 'moment'

  export default {
    name: 'TableHistory',

    data: () => ({
      headers: [
          {
            text: 'Stasiun',
            align: 'start',
            value: 'station',
          },
          { text: 'Lokasi', value: 'location' },
          { text: 'Curah Hujan (mm)', value: 'curah' },
          { text: 'Waktu Awal', value: 'start' },
          { text: 'Waktu Akhir', value: 'end' },
        ],
      historical:[],
      data:[],
      tableLoad:true,
      devices:[],
      offset:0,
      lastData:{},
      beforeData:[],
      firstData:{},
      lastPage:1,
      page:1,
      itemsPerPage:10,
      time:[],
      modal2:false,
      dates:['2022-07-27', '2022-07-29'],
      setByLocation:false,
      dateFilter:false,
    }),
    async mounted () {
      let loader = this.$loading.show()
      const date=new Date();
      this.offset=date.getTimezoneOffset()/(-60)
      const today = Date.now()/1000;
      this.dates=[moment.unix(today-604800).utcOffset(this.offset).format("YYYY-MM-DD"),moment.unix(today).utcOffset(this.offset).format("YYYY-MM-DD")]
      await db.collection('roleSetting').doc(localStorage.getItem("role")).get().then((doc)=> {
        this.setByLocation=doc.data().location
      })

      var deviceRef=db.collection('device')
      if (this.setByLocation) {
        deviceRef= db.collection('device').where('location','==',localStorage.getItem('location'))
      }
      await deviceRef.get().then((collectionSnapshot) => {
        this.devices=[]
        collectionSnapshot.forEach((doc) => {
          if (doc.data().location=='MARNOV') {
            if (localStorage.getItem('location')=='MARNOV') {
              this.devices.push({id: doc.id, ...doc.data()})
            }
          } else {
            this.devices.push({id: doc.id, ...doc.data()})
          }
        });
        loader.hide()
      })
      await this.getData(1,this.itemsPerPage,this.setByLocation)
      
    },
    methods: {
      updateTime (time) {
        return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
      },
      async getData (page,items,setByLocation) {
        let location=localStorage.getItem('location')
        this.tableLoad= true 
        var dataRef = db.collection('notification').where('notif','==','stop').orderBy("time","desc").limit(items)
        if (localStorage.getItem('location')!='MARNOV') {
          dataRef = db.collection('notification').where('notif','==','stop').where('location','in',['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE']).orderBy("time","desc").limit(items)
        }
        if (setByLocation) {
          dataRef = db.collection('notification').where('notif','==','stop').where('location','==',location).orderBy("time","desc").limit(items)
        }
        
        //forward
        if (page>this.lastPage && (page!=1)) {
          this.beforeData.push(this.firstData)
          this.beforeData[page-1]=this.firstData
          this.lastPage=page
          dataRef = db.collection('notification').where('notif','==','stop').orderBy("time","desc").startAfter(this.lastData).limit(items)
          if (localStorage.getItem('location')!='MARNOV') {
            dataRef = db.collection('notification').where('notif','==','stop').where('location','in',['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE']).orderBy("time","desc").startAfter(this.lastData).limit(items)
          }
          if (setByLocation) {
            dataRef = db.collection('notification').where('notif','==','stop').where('location','==',location).orderBy("time","desc").startAfter(this.lastData).limit(items)
          }
        } 
        // First Page
        else if (page==1) {
          this.lastPage=page
          dataRef = db.collection('notification').where('notif','==','stop').orderBy("time","desc").limit(items)
          if (localStorage.getItem('location')!='MARNOV') {
            dataRef = db.collection('notification').where('notif','==','stop').where('location','in',['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE']).orderBy("time","desc").limit(items)
          }
          if (setByLocation) {
            dataRef = db.collection('notification').where('notif','==','stop').where('location','==',location).orderBy("time","desc").limit(items)
          }
        } 
        //backward
        else if (page<this.lastPage) {
          this.lastPage=page
          console.log(page)
          dataRef = db.collection('notification').where('notif','==','stop').orderBy("time","desc").limit(items).startAt(this.beforeData[page])
          if (localStorage.getItem('location')!='MARNOV') {
            dataRef = db.collection('notification').where('notif','==','stop').where('location','in',['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE']).orderBy("time","desc").limit(items).startAt(this.beforeData[page])
          }
          if (setByLocation) {
            dataRef = db.collection('notification').where('notif','==','stop').where('location','==',location).orderBy("time","desc").limit(items).startAt(this.beforeData[page])
          }
        }
        await dataRef.get().then((collectionSnapshot) => {
          let i=0
          this.historical=[]
          let index=0
          let count=0
          collectionSnapshot.forEach((doc) => {
            if (count==0) {
              this.firstData=doc
              count++
            }
            index = this.devices.findIndex(x => x.id === doc.data().id);
            if (index!=-1) {
              this.historical.push({curah:doc.data().curah})
              this.historical[i].did=doc.id
              this.historical[i].id=doc.data().id
              this.historical[i].end = doc.data().time
              this.historical[i].start = doc.data().start
              i++
            }
            this.lastData=doc;
          });
          for (i=0;i<this.historical.length;i++) {
            for (let j=0;j<this.devices.length;j++) {
              if (this.historical[i].id==this.devices[j].id) {
                this.historical[i].location=this.devices[j].location
                this.historical[i].station=this.devices[j].station
                break;
              }
            }
          }
          this.data=this.historical
          this.tableLoad=false
        })  
      },
      async getDataDates(dates,setByLocation) {
        this.dateFilter=true
        let location=localStorage.getItem('location')
        this.tableLoad= true 
        let localDates=[dates[0],dates[1]]
        if (moment(dates[0]).unix()<moment(dates[1]).unix()) {
          localDates[0] = dates[1]
          localDates[1] = dates[0]
        }
        var dataRef = db.collection('notification').where('notif','==','stop').orderBy("time","desc").startAfter(moment(localDates[0]).unix()+86400).endBefore(moment(localDates[1]).unix())
        if (localStorage.getItem('location')!='MARNOV') {
          dataRef = db.collection('notification').where('notif','==','stop').where('location','in',['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE']).orderBy("time","desc").startAfter(moment(localDates[0]).unix()+86400).endBefore(moment(localDates[1]).unix())
        }
        if (setByLocation) {
          dataRef = db.collection('notification').where('notif','==','stop').where('location','==',location).orderBy("time","desc").startAfter(moment(localDates[0]).unix()+86400).endBefore(moment(localDates[1]).unix())
        }
        
        await dataRef.get().then((collectionSnapshot) => {
          let i=0
          this.historical=[]
          let index=0
          collectionSnapshot.forEach((doc) => {
            index = this.devices.findIndex(x => x.id === doc.data().id);
            if (index!=-1) {
              this.historical.push({curah:doc.data().curah})
              this.historical[i].did=doc.id
              this.historical[i].id=doc.data().id
              this.historical[i].end = doc.data().time
              this.historical[i].start = doc.data().start
              i++
            }
          });
          for (i=0;i<this.historical.length;i++) {
            for (let j=0;j<this.devices.length;j++) {
              if (this.historical[i].id==this.devices[j].id) {
                this.historical[i].location=this.devices[j].location
                this.historical[i].station=this.devices[j].station
                break;
              }
            }
          }
          this.data=this.historical
          this.tableLoad=false
        })  
      }
    },
    computed: {
      dateRangeText () {
        return this.dates.join(' ~ ')
      },
    },
  }
</script>
